import React from "react";
import RecoveryForm from "./RecoveryForm";
import PromotionalPanel from "../PromotionalPanel";

const RecoveryPage: React.FC = () => {
    return (
        <div className='min-h-screen w-full flex overflow-hidden '>
            <div className='w-full min-h-full flex flex-col gap-4 lg:gap-0 lg:flex-row bg-black/30 lg:bg-transparent lg:p-8'>
                <PromotionalPanel
                    title='A new way to buy and sell cars'
                    imageUrl='/bg-car.png'
                    cta={{
                        title: "Do you already have an account?",
                        text: "Sign In",
                        url: "/account/sign-in",
                    }}
                />
                <RecoveryForm />
            </div>
        </div>
    );
};

export default RecoveryPage;